/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Тип услуги для грузоместа
 */
export type OrderCargoServiceType = {
  /**
   * Тип услуги
   */
  id: OrderCargoServiceType.Id
  /**
   * Название типа услуги
   */
  name: string
}
export namespace OrderCargoServiceType {
  /**
   * Тип услуги
   */
  export enum Id {
    CUSTOM = 'custom',
    PALLET = 'pallet'
  }
}
